import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MmaoComponent } from '@app/shared/components/mmao/mmao.component';
import { OpenMmaoPopinDirective } from '@app/shared/components/mmao/directives/open-mmao-popin.directive';
import { MmaoPopinComponent } from '@app/shared/components/mmao/mmao-popin/mmao-popin.component';
import { MatDialogModule } from '@angular/material/dialog';

import { MmaoHistoryComponent } from '@app/shared/components/mmao/mmao-history/mmao-history.component';
import { MmaoService } from '@app/shared/components/mmao/services/mmao.service';
import { MmaoFormComponent } from '@app/shared/components/mmao/mmao-form/mmao-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { ImagesModule } from '../images/images.module';
import { AddToCartModule } from '@app/shared/directives/add-to-cart/add-to-cart.module';

@NgModule({
  imports: [CommonModule, SharedModule, MatDialogModule, ReactiveFormsModule, ImagesModule, AddToCartModule],
  declarations: [MmaoComponent, OpenMmaoPopinDirective, MmaoPopinComponent, MmaoHistoryComponent, MmaoFormComponent],
  exports: [MmaoComponent, OpenMmaoPopinDirective, MmaoHistoryComponent, MmaoFormComponent],
  providers: [MmaoService],
  entryComponents: [MmaoPopinComponent]
})
export class MmaoModule {}
